import { HTMLAttributes, ReactNode } from "react";
import styles from "./Card.module.css";

interface CardProps extends HTMLAttributes<HTMLElement> {
  variant?: "surface" | "tile" | "glass" | "ink";
  tint?: string;
  as?: "div" | "section" | "article" | "aside";
  children?: ReactNode;
}

export default function Card({
  variant = "surface",
  tint,
  as: Tag = "div",
  className,
  style,
  children,
  ...rest
}: CardProps) {
  const cls = [styles.card, styles[variant], className].filter(Boolean).join(" ");
  const merged = tint ? { ...style, background: tint } : style;
  return (
    <Tag className={cls} style={merged} {...rest}>
      {children}
    </Tag>
  );
}
